export default __webpack_public_path__ + "static/media/GoodMannersWithYourTeachers_06.73368fe1.png";